// The comparison pages listed on /compare. A test keeps this list equal to the files in
// src/routes/_site/compare/, so a new comparison page cannot be left off the hub.
export interface ComparePage {
  slug: string
  name: string
  /** A literal route path, so a router link to it is type checked. */
  href: `/compare/${string}`
}

export const COMPARE_PAGES = [
  { slug: 'uptimerobot', name: 'UptimeRobot', href: '/compare/uptimerobot' },
  { slug: 'betterstack', name: 'Better Stack', href: '/compare/betterstack' },
  { slug: 'pingdom', name: 'Pingdom', href: '/compare/pingdom' },
  { slug: 'datadog', name: 'Datadog', href: '/compare/datadog' },
  { slug: 'hetrixtools', name: 'HetrixTools', href: '/compare/hetrixtools' },
  { slug: 'statuscake', name: 'StatusCake', href: '/compare/statuscake' },
  { slug: 'checkly', name: 'Checkly', href: '/compare/checkly' },
  { slug: 'hyperping', name: 'Hyperping', href: '/compare/hyperping' },
  { slug: 'ohdear', name: 'Oh Dear', href: '/compare/ohdear' },
  { slug: 'uptime-kuma', name: 'Uptime Kuma', href: '/compare/uptime-kuma' },
  { slug: 'pulsetic', name: 'Pulsetic', href: '/compare/pulsetic' },
  { slug: 'freshping', name: 'Freshping', href: '/compare/freshping' },
  { slug: 'cronitor', name: 'Cronitor', href: '/compare/cronitor' },
  { slug: 'healthchecks', name: 'Healthchecks.io', href: '/compare/healthchecks' },
  { slug: 'grafana', name: 'Grafana Cloud', href: '/compare/grafana' },
  { slug: 'newrelic', name: 'New Relic', href: '/compare/newrelic' },
  { slug: 'site24x7', name: 'Site24x7', href: '/compare/site24x7' },
  { slug: 'uptrends', name: 'Uptrends', href: '/compare/uptrends' },
  { slug: 'updown', name: 'Updown.io', href: '/compare/updown' },
  { slug: 'gatus', name: 'Gatus', href: '/compare/gatus' },
  { slug: 'statping', name: 'Statping-ng', href: '/compare/statping' },
  { slug: 'phare', name: 'Phare', href: '/compare/phare' },
  { slug: 'nixstats', name: 'NixStats', href: '/compare/nixstats' },
  { slug: 'montastic', name: 'Montastic', href: '/compare/montastic' },
] as const satisfies readonly ComparePage[]
